var lib_core = require("lib-core");
var ui_extensions = require("ui-extensions");

var FootprintAddStateMachine = require("./footprintAddStateMachine.js");
var AssetAdderModel = require("../../../shared/extensions/assetAdder/assetAdderModel");
var AssetAdderView = require("../../../shared/extensions/assetAdder/assetAdderView");

var FootprintAddController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);
};
FootprintAddController.inject = {
    switcherController : ui_extensions.SwitcherController,
    userController : lib_core.UserController
};

lib_core.inherit(FootprintAddController, lib_core.Controller);

module.exports = FootprintAddController;

FootprintAddController.prototype.createView = function () {
    return new AssetAdderView(this.getModel(), this.getStatemachine());
};

FootprintAddController.prototype.createModel = function () {
    return new AssetAdderModel();
};

FootprintAddController.prototype.createStateMachine = function () {
    var switcherModel = this.switcherController.getModel();
    var userModel = this.userController.getModel();
    return new FootprintAddStateMachine(this.root, this.getModel(), this.getCollection(), switcherModel, userModel, this.configuration.url);
};

FootprintAddController.prototype.getCollection = function () {
    if(this.configuration.collection) {
        return this.root.findByPath(this.configuration.collection);
    }

    return null;
};
